import styled, { css } from 'styled-components';
import { gray10, gray95 } from '@spotify-internal/encore-foundation';
import { fontWeightBold, textOverflow } from "../../styles";
import Type from "../Type";
export default styled(Type).attrs({
  component: 'h3',
  variant: Type.body2,
  condensed: true
}).withConfig({
  displayName: "Title",
  componentId: "j0wu1x-0"
})(["font-weight:", ";display:block;color:", ";", ";"], fontWeightBold, function (props) {
  return props.theme.tableThumbnail === 'dark' ? gray95 : gray10;
}, function (props) {
  return props.truncate && css(["", ";"], textOverflow());
});